export default __webpack_public_path__ + "static/media/background3.7fe25389.svg";